
export const QUICK_LINKS = [
  { label: "اخبار", path: "/news" },
  { label: "مسابقات", path: "/competitions" },
  { label: "تورنمنت‌ ها", path: "/tournaments" },
  { label: "باشگاه‌ها", path: "/clubs" },
  { label: "بازیکنان", path: "/players" },
  { label: "درباره هیئت", path: "/about" },
  { label: "ارتباط با ما", path: "/contact" },
];

export const CONTACTS = [
  { icon: "phone", label: "083-۰۰۰۰۰۰۰" },
  { icon: "instagram", label: "اینستاگرام" },
  { icon: "telegram", label: "کانال تلگرام" },
];

